import React, { Component } from "react";

import { Wrapper, Button, Row, Icon, Copy } from "app/NativeComponents/common";

class TabButton extends Component {
  render() {
    const {
      title,
      icon,
      count,
      slug,
      selected_owner_tab,
      colors,
      onPress
    } = this.props;
    if (slug == selected_owner_tab) {
      return (
        <Button
          onPress={onPress}
          style={{
            padding: 15,
            borderTopLeftRadius: 15,
            borderTopRightRadius: 15,
            backgroundColor: colors.background_color
          }}
        >
          <Row>
            <Icon icon={icon} />
            <Copy style={{ marginLeft: 5 }}>{title}</Copy>
            <Copy style={{ marginLeft: 5 }}>({count})</Copy>
          </Row>
        </Button>
      );
    }

    return (
      <Button
        onPress={onPress}
        style={{
          padding: 15
        }}
      >
        <Row>
          <Icon icon={icon} />
          <Copy style={{ marginLeft: 5 }}>({count})</Copy>
        </Row>
      </Button>
    );
  }
}

export default TabButton;
